<template>
  <div class="analysisItem" ref="analysisItemRef" :style="
      `top:${moveTop}px;transition:${isDragging ? '0' : '.3s'}s;${
        isDragging ? 'z-index:999' : ''
      }`
    "
		@mousedown="moveDown($event)">
    <div class="ai-header">
      <div class="ai-h-left" @click.stop="changeOpenItem(!openItem)">
        <span
          :class="['ai-h-l-icon', openItem ? 'ai-h-l-iconActive' : '']"
        ></span>
        <span class="ai-h-l-text" v-if="!editTitle">{{
          data.jsonData.anotherName
            ? data.jsonData.anotherName
            : data.jsonData.name
        }}</span>

        <div class="a_h_l_t_input" v-if="editTitle" @click.stop="() => {}">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            @submit.native.prevent
          >
            <el-form-item prop="name">
              <el-input
                v-model="form.name"
                @blur="editNameCheckFn()"
                @keyup.enter.native="editNameCheckFn()"
                ref="editNameInputRef"
                placeholder="请输入新的名称"
              ></el-input>
            </el-form-item>
            <!--   @blur="editNameCheckFn()" -->
          </el-form>
        </div>
        <el-tooltip
          v-if="!editTitle"
          class="item"
          effect="light"
          content="修改名称"
          placement="top"
        >
          <span class="a_h_l_edit" @click.stop="editTitleFn()" v-if="!isDrag">
            <img
              src="../../../../assets/icon/classroomObservation/editIcon2.svg"
            />
          </span>
        </el-tooltip>
      </div>
      <div class="ai-h-right" v-if="!isDrag">
        <span style="width: 100px" class="generateError" v-if="loadNum == 2"
          >优化失败
        </span>
        <span style="width: 100px" v-if="loadNum == 1">
          <span v-if="loading" class="generate">
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/generate.svg')
              "
            />
            生成中...
          </span>
          <span v-else class="generateSuccess">
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/success.svg')
              "
            />
            生成完成
          </span>
        </span>
        <span
          v-if="loadNum == 0 && !openItem && tid"
          class="ai-h-r-icon4"
          @click.stop="delBtn()"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="删除"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/del.svg')
              "
            />
          </el-tooltip>
        </span>

        <span
          v-if="loadNum == 0 && openItem"
          :class="['ai-h-r-icon1', showIndex <= 0 ? 'ai_h_r_iconOpacity' : '']"
          @click.stop="changeShowIndex(-1)"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="上一个"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/back.svg')
              "
            />
          </el-tooltip>
        </span>

        <span
          v-if="loadNum != 1 && openItem"
          :class="[
            showIndex >= historyResult.length - 1 ? 'ai_h_r_iconOpacity' : ''
          ]"
          @click.stop="changeShowIndex(1)"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="下一个"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/back.svg')
              "
            />
          </el-tooltip>
        </span>

        <span
          v-if="loadNum != 1 && openItem && tid"
          @click.stop="editBtn(true)"
        >
          <el-tooltip
            class="item"
            effect="light"
            content="优化"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/edit.svg')
              "
            />
          </el-tooltip>
        </span>

        <span v-if="loadNum != 1 && openItem && tid" @click="editEcharts(true)">
          <el-tooltip
            class="item"
            effect="light"
            content="生成图表"
            placement="top"
          >
            <img
              :src="
                require('../../../../assets/icon/classroomObservation/echartIcon.svg')
              "
            />
          </el-tooltip>
        </span>

        <!-- <span class="ai-h-r-icon4" @click.stop="delBtn()"></span> -->
      </div>
    </div>
    <div class="ai-main" v-if="openItem && !isDrag">
      <div class="a-m-brief" v-if="showBrief">
        {{ data.jsonData.result }}
      </div>
      <!-- 图 -->
      <eChartTemplate
        style="max-height: 600px;max-width: 600px;width: 100%;height: 600px;margin: auto;"
        :data="data.jsonData.eChartData"
        v-if="
          data.jsonData.eChartData &&
            converter(data.jsonData.name) == converter('S-T分析：师生互动分析')
        "
      />

      <!-- 光谱图 -->
      <echartsSpectrogram
        style="max-height: 200px;max-width: 90%;width: 90%;height: 200px;margin: auto;margin-bottom: 50px;"
        v-if="data.jsonData.spectrogramData && data.jsonData.mId == 'bfe844b1-7a45-11ef-9b30-005056b86db5'"
        :data="data.jsonData.spectrogramData"
      />

      <eChartTemplate
        style="width: 100%;height: 400px;"
        :data="data.jsonData.eChartData"
        v-if="
          data.jsonData.eChartData &&
            converter(data.jsonData.name) != converter('S-T分析：师生互动分析')
        "
      />

			<echartsRTCH v-if="data.jsonData.RT && data.jsonData.CH" :data="{RT:data.jsonData.RT,CH:data.jsonData.CH}" style="width: 100%;height: 350px;display: flex;justify-content: center;margin-bottom: 20px;"/>
      <!-- <div class="rtCh" v-if="data.jsonData.RT && data.jsonData.CH">
        <img
          :src="
            require('../../../../assets/icon/classroomObservation/rt-ch.png')
          "
        />
        <div>
          <span>RT={{ data.jsonData.RT }}</span>
          <span>CH={{ data.jsonData.CH }}</span>
        </div>
      </div> -->
      <mdView :text="data.jsonData.content" />
    </div>
    <!-- <editNameDialog ref="editNameDialogRef" @success="changeNameSuccess"/> -->
  </div>
</template>

<script>
var OpenCC = require("opencc-js");
let converter2 = OpenCC.Converter({
  from: "hk",
  to: "cn"
});
import mdView from "./mdView.vue";
import eChartTemplate from "./eChartTemplate";
import { v4 as uuidv4 } from "uuid";
import echartsSpectrogram from "./echartsSpectrogram";
// import editNameDialog from './editNameDialog.vue'
import markdownIt from "markdown-it";
import echartsRTCH from './echartsRTCH'
export default {
  emits: ["delItem", "editItem", "saveItem"],
  components: {
    mdView,
    eChartTemplate,
    echartsSpectrogram,
		echartsRTCH
    // editNameDialog
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    bmData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dialogTagDataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    },
    tid: {
      type: String,
      require: true
    },
    fileId: {
      type: String,
      require: true
    },
    showBrief: {
      type: Boolean,
      default: true
    },
		isDrag: {
      type: Boolean,
      default: false
    },
    dialogTagList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      openItem: false,
      loading: false,
      loadNum: 0,
      userId: this.$route.query["userid"],
      showIndex: 0,
      historyResult: [],
      tableData: [],
      imgTypeList: [
        "png",
        "jpg",
        "jpeg",
        "bmp",
        "gif",
        "webp",
        "psd",
        "svg",
        "tiff"
      ],
      oldData: {},
      form: {
        name: ""
      },
      editTitle: false,
      rules: {
        name: [
          { required: true, trigger: "change", message: "请输入新的名称" },
          {
            min: 1,
            max: 20,
            trigger: "change",
            message: "长度需在1-20个字符之间"
          }
        ]
      },
			startY: 0,
      startTop: 0,
      moveTop: 0,
      isDragging: false,
      dragBoxList: [],
      enterDrag: null
    };
  },
  computed: {
    checkFileType() {
      return url => {
        return url.split(".").pop();
      };
    },
    converter() {
      return function(word) {
        return converter2(word);
      };
    }
  },
  watch: {
    // showIndex(){
    // 	let _copyData = JSON.parse(JSON.stringify(this.data));
    // 	_copyData.jsonData = this.historyResult[this.showIndex];
    // 	_copyData.json_data = JSON.stringify(_copyData.jsonData);
    // 	this.$emit("editItem", this.data.id, _copyData);
    // }
  },
  methods: {
    changeOpenItem(newValue) {
			if(this.isDrag)return;
      if (this.loading == true && this.loadNum != 0)
        return this.$message("请稍后...");
      this.loadNum = 0;
      this.openItem = newValue;
    },
    editBtn(flag = false) {
      // if (!flag) return console.log("不执行获取");
      this.loadNum = 1;
      this.getData(1);

      // this.ajax
      // 	.post("https://gpt4.cocorobo.cn/ai_agent_park_chat", parm)
      // 	.then((res) => {
      // 		let _data = res.data.FunctionResponse;
      // 		if (
      // 			!_data.message ||
      // 			_data.message.indexOf("由于我无法直接访问您上传的文件内容") > -1
      // 		) {
      // 			this.loading = false;
      // 			this.loadNum = 2;
      // 			return this.$message.error("AI无法识别优化");
      // 		}
      // 		let _copyData = JSON.parse(JSON.stringify(this.data));
      // 		// _copyData.jsonData.result = "";
      // 		_copyData.jsonData.content = _data.message;
      // 		_copyData.jsonData.dataFileList = [];
      // 		_copyData.jsonData.fileList = [];
      // 		_copyData.json_data = JSON.stringify(_copyData.jsonData);
      // 		if (this.historyResult.length == 0) {
      // 			this.historyResult.push(_copyData.jsonData);
      // 		} else {
      // 			this.historyResult.splice(
      // 				this.showIndex + 1,
      // 				0,
      // 				_copyData.jsonData
      // 			);
      // 		}
      // 		this.changeShowIndex(1);
      // 		this.loading = false;
      // 	})
      // 	.catch((err) => {
      // 		this.loadNum = 2;
      // 		this.$message.error("AI无法识别优化");
      // 		this.loading = false;
      // 	});
    },

    editEcharts(flag = false) {
      if (!flag) return console.log("不执行获取");
      this.loadNum = 1;
      this.getData(0);
    },
    getAtAuContent(_uid) {
      let _source = new EventSource(
        `https://gpt4.cocorobo.cn/question/${_uid}`
      ); //http://gpt4.cocorobo.cn:8011/question/   https://gpt4.cocorobo.cn/question/
      let _allText = "";
      let _mdText = "";
      let _copyData = JSON.parse(JSON.stringify(this.data));
      // _copyData.jsonData.result = "";
      _copyData.jsonData.content = "";
      _copyData.jsonData.dataFileList = [];
      _copyData.jsonData.fileList = [];
      if (this.historyResult.length == 0) {
        this.historyResult.push(_copyData.jsonData);
      } else {
        this.historyResult.splice(this.showIndex + 1, 0, _copyData.jsonData);
      }
      this.showIndex++;
      this.$emit("editItem", this.data.id, _copyData);
      // const md = new MarkdownIt();
      _source.onmessage = _e => {
        let _eData = JSON.parse(_e.data);
        if (_eData.content.replace("'", "").replace("'", "") == "[DONE]") {
          let _result = [];
          if ("result" in _eData) {
            _result = _eData.result;
            for (let i = 0; i < _result.length; i++) {
              _mdText = _mdText.replace(_result[i].text, _result[i].fileName);
            }
          }
          _mdText = _mdText.replace("_", "");
          _copyData.jsonData.content = _mdText;
          this.loading = false;
          this.loadNum = 0;
          this.$emit("editItem", this.data.id, _copyData);
          this.$emit("saveItem", this.data.id, _copyData);
          _source.close();
        } else {
          let _text = _eData.content.replace("'", "").replace("'", "");
          if (_allText == "") {
            _allText = _text.replace(/^\n+/, ""); //去掉回复消息中偶尔开头就存在的连续换行符
          } else {
            _allText += _text;
          }
          _mdText = _allText + "_";
          _mdText = _mdText.replace(/\\n/g, "\n");
          _mdText = _mdText.replace(/\\/g, "");
          if (_allText.split("```").length % 2 == 0) _mdText += "\n```\n";
          //转化返回的回复流数据
          // _mdText = md.render(_mdText);
          _copyData.jsonData.content = _mdText;
          this.$emit("editItem", this.data.id, _copyData);
          // 处理流数据
        }
      };
    },
    getData(type = 0) {
      if (
        this.data.jsonData.mId == 'bfe844b1-7a45-11ef-9b30-005056b86db5' &&
        type == 1
      ) {
        return this.getSpectrogram("", type);
      }

      if (!this.bmData.editorBarData || this.bmData.editorBarData.type != 0) {
        this.loadNum = 2;
        return this.$message.info("请上传表格形式的转录文稿");
      }

      try {
        let _result = [];
        let _data = this.bmData.editorBarData.content;
        let _div = document.createElement("div");
        _div.innerHTML = _data;
        let _tableRows = _div.querySelectorAll(`table tbody tr`);
        _tableRows.forEach((i, index) => {
          if (index == 0) return;
          let obj = {
            index: i.cells[0].textContent,
            startTime: i.cells[1].textContent,
            endTime: i.cells[2].textContent,
            message: i.cells[3].textContent,
            time: i.cells[4].textContent,
            role: i.cells[5] ? i.cells[5].textContent : "",
            behavior: i.cells[6] ? i.cells[6].textContent : ""
          };
          _result.push(obj);
        });
        if (_result.length == 0) return this.$message.error("未找到表格数据");
        if (
          this.data.jsonData.name == this.converter("S-T分析：课堂时间分配")
        ) {
          this.getTimeAllocationData(_result, type);
        } else if (
          this.data.jsonData.name == this.converter("S-T分析：师生互动分析")
        ) {
          this.getInteractionAnalysisData(_result, type);
        } else if (
          this.data.jsonData.name == this.converter("S-T分析：教学模式分析")
        ) {
          this.getTeachingModeData(_result, type);
        } else if (
          this.data.jsonData.mId == 'bfe844b1-7a45-11ef-9b30-005056b86db5'
        ) {
          return this.getSpectrogram(_result, type);
        } else {
          return this.$message.error("未找到对应的分析");
        }
      } catch (error) {
        console.log(error);
        this.loadNum = 2;
        this.loading = false;
        return this.$message.error("生成分析失败");
      }
    },
    // 课堂时间分配
    getTimeAllocationData(_dataList, type = 0) {
      this.loading = true;
      this.openItem = false;
      let _data = _dataList.reduce(
        (pre, cur) => {
          if (cur.role == "学生") {
            pre[1].value += this.convertToSeconds(cur.time);
          } else if (cur.role == "老师") {
            pre[0].value += this.convertToSeconds(cur.time);
          }
          return pre;
        },
        [
          { value: 0, name: "老师" },
          { value: 0, name: "学生" }
        ]
      );
      let _dataPercentage = JSON.parse(JSON.stringify(_data));
      _data.forEach((i, index) => {
        _dataPercentage[index].percentage =
          (
            (i.value / _data.reduce((pre, cur) => pre + cur.value, 0)) *
            100
          ).toFixed(2) + "%";
      });

      if (type == 1) {
        let _msg = `这是某一节课的师生时间占比，请你分析，写出结论，并给出指导建议。请使用3句完整的话，分析并给出建议。 请注意，当老师或学生的时间占比在【40~59%】之间的时候，也认为师生占比约为1:1，各占50%，师生时间占比比较均衡。
师生时间占比数据：
老师占比：${_dataPercentage[0].percentage}
学生占比：${_dataPercentage[1].percentage}
`;
        return this.getAiContent(_msg);
      }

      const _option = {
        // title: {
        //   text: "课堂时间分配",
        //   left: "center"
        // },
        tooltip: {
          // text: "课堂时间分配",
          left: "center",
          trigger: "item",
          formatter: "{a} <br/>{b}: {d}%" // {a}为系列名，{b}为数据名，{d}为百分比
        },
        legend: {
          top: "5%",
          // orient: "vertical",
          left: "center"
        },
        series: [
          {
            name: "课堂时间分配",
            type: "pie",
            radius: ["40%", "70%"],
            // avoidLabelOverlap: false,
            label: {
              formatter: "{b}: {d}%"
              // show: false,
              // position: "center",
            },
            emphasis: {
              label: {
                show: true,
                // fontSize: 40,
                // fontWeight: "bold",
                formatter: "{b}: {d}%" // 显示百分比
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            // labelLine: {
            // 	show: false,
            // },
            data: _data
          }
        ]
      };


      let _copyData = JSON.parse(JSON.stringify(this.data));
      _copyData.jsonData.eChartData = _option;
      _copyData.json_data = JSON.stringify(_copyData.jsonData);
      if (this.historyResult.length == 0) {
        this.historyResult.push(_copyData.jsonData);
      } else {
        this.historyResult.splice(this.showIndex + 1, 0, _copyData.jsonData);
      }
      this.changeShowIndex(1);
      this.loading = false;
    },
    // 师生互动分析
    getInteractionAnalysisData(_dataList, type = 0) {
      this.loading = true;
      this.openItem = false;
      let _pushData = [0, 0];
      let _result = [];
      _dataList.forEach(i => {
        if (i.role == "老师") {
          _pushData[0] += this.convertToSeconds(i.time);
        } else if (i.role == "学生") {
          _pushData[1] += this.convertToSeconds(i.time);
        }
        return _result.push(JSON.parse(JSON.stringify(_pushData)));
      });
      let _flatArray = _result.flat();
      const _max = Math.max(..._flatArray);
      const _maxValue = Math.ceil(_max / 100) * 100;

      if (type == 1) {
        let _msg = `
## 任务 
请你结合 FIAS 相关的知识，根据以下提供给你的课堂原始数据（包含S和t的数据），请你具体描述整个课堂S行为与T行为的持续性与变化性。比如，课堂一开始老师占比主导，大约5分钟之后，进入到学生为主的小组讨论环节。在整个课堂之中，老师与学生的互动比较频繁，老师会频繁询问学生问题，引导学生思考。之后是授课时间与问答时间。等等。
## 输出要求 请使用自然语言进行描述，使用不超过5句完整的话进行整体性、概括性的描述，不要包含具体的时长信息。总结性概括之后，使用1句话对整个课堂的教师引导行为进行鼓励和评价，再使用1句话给出相应的优化建议。
## 你的知识库 定义与目的：S-T图，即学生-教师（Student-Teacher）图，主要用于记录和分析课堂上的学生行为（S）与教师行为（T）的时间分布。这种图形能够帮助教育专家和教师可视化课堂互动的流程，从而判断课堂的教学型态，如练习型、对话型、讲授型或混合型。 绘制方法：S-T图的绘制开始于教学的起始时刻，纵轴表示学生行为（S），横轴表示教师行为（T）。实际课堂观察或录像回放中，按照固定时间间隔（通常每30秒）采样，将对应的行为按时间顺序标记在相应的轴上。通过这种方法，可以清晰看到课堂上教师行为与学生行为的交替模式及其随时间的变化。 应用场景：例如，一个典型的应用是在分析不同类型课堂活动时使用S-T图。在讲授型课堂中，教师行为的时间占比会较高，S-T图显示较长的横轴（T行为）延续；而在练习型或对话型课堂中，学生行为的时间占比增高，显示为较长的纵轴（S行为）。
## 课堂实录
${JSON.stringify(_dataList)}
`;
        return this.getAiContent(_msg);
      }

      const _option = {
        xAxis: {
          name: "老师", // X轴标题
          nameLocation: "end", // 标题位置
          scale: true,
          min: 0,
          max: _maxValue
        },
        yAxis: {
          name: "学生", // Y轴标题
          nameLocation: "end", // 标题位置
          scale: true,
          min: 0,
          max: _maxValue
        },
        grid: {
          containLabel: true
        },
        series: [
          {
            name: "数据",
            step: "start",
            data: _result,
            type: "line"
          },
          {
            name: "对角线",
            type: "line",
            data: [
              [0, 0],
              [_maxValue, _maxValue]
            ],
            lineStyle: {
              type: "dashed"
            },
            markLine: {
              symbol: ["none", "none"]
            }
          }
        ]
      };

      let _copyData = JSON.parse(JSON.stringify(this.data));
      _copyData.jsonData.eChartData = _option;
      _copyData.json_data = JSON.stringify(_copyData.jsonData);
      if (this.historyResult.length == 0) {
        this.historyResult.push(_copyData.jsonData);
      } else {
        this.historyResult.splice(this.showIndex + 1, 0, _copyData.jsonData);
      }
      this.changeShowIndex(1);
      this.loading = false;
    },
    // 教学模式分析
    getTeachingModeData(_dataList, type = 0) {
      this.openItem = false;
      this.loading = true;
      let _continuousTime = 0;
      let _totalTime = 0;
      let _continuousRole = "老师";
      let _teacherTime = 0;
      _dataList.forEach((item, index) => {
        if (index == 0) {
          //第一个
          _continuousRole = item.role;
        } else if (_dataList.length - 1 == index) {
          //最后一个
          if (_continuousRole == item.role) {
            //连续对话了
            _continuousTime += this.convertToSeconds(_dataList[index - 1].time);
            _continuousTime += this.convertToSeconds(item.time);
          } else {
            //没连续对话
            if (index >= 2) {
              if (_dataList[index - 2].role == _dataList[index - 1].role) {
                _continuousTime += this.convertToSeconds(
                  _dataList[index - 1].time
                );
              } else {
                _continuousRole = item.role;
              }
            } else {
              _continuousRole = item.role;
            }
          }
        } else {
          if (_continuousRole == item.role) {
            //连续对话了
            _continuousTime += this.convertToSeconds(_dataList[index - 1].time);
          } else {
            //没连续对话
            if (index >= 2) {
              if (_dataList[index - 2].role == _dataList[index - 1].role) {
                _continuousTime += this.convertToSeconds(
                  _dataList[index - 1].time
                );
              } else {
                _continuousRole = item.role;
              }
            } else {
              _continuousRole = item.role;
            }
          }
        }

        if (item.role == "老师") {
          _teacherTime += this.convertToSeconds(item.time);
        }

        _totalTime += this.convertToSeconds(item.time);
      });

      let _RT = (_teacherTime / _totalTime).toFixed(2);
      let _CH = (_continuousTime / _totalTime).toFixed(2);

      if (type == 1) {
        let _msg = `## 任务
根据FIAS（弗兰德斯互动分析系统）理论，计算获得某一节课的RT和CH值。请你结合FIAS相关知识进行分析，使用3句完整的话对整个课堂进行分析，需注意包含这些内容：分析该课堂所属的教学模型，描述课堂的整体表现与特征，肯定老师做出的努力，以及给出相应的建议。 
## 你的知识 
根据RT和CH的值，教学模式通常被分为以下几种类型： 练习型：RT ≤ 0.3，表示学生行为占主导，教师行为较少。 讲授型：RT ≥ 0.7，表示教师行为占主导，学生参与较少。 对话型：CH ≥ 0.4，表示师生之间有较多的互动和转换。 混合型：0.3 < RT < 0.7，CH < 0.4，表示教学中既有教师讲授也有学生参与，但两者都不占绝对优势。
## 数据
RT：${_RT}
CH：${_CH}
`;
        return this.getAiContent(_msg);
      }

      let _copyData = JSON.parse(JSON.stringify(this.data));
      _copyData.jsonData.RT = _RT;
      _copyData.jsonData.CH = _CH;
      _copyData.json_data = JSON.stringify(_copyData.jsonData);
      if (this.historyResult.length == 0) {
        this.historyResult.push(_copyData.jsonData);
      } else {
        this.historyResult.splice(this.showIndex + 1, 0, _copyData.jsonData);
      }
      this.changeShowIndex(1);
      this.loading = false;
    },
    getAiContent(_msg) {
      let parm = {
        assistant_id: "f8e1ebb2-2e0d-11ef-8bf4-12e77c4cb76b",
        message: _msg,
        session_name: uuidv4(),
        userId: this.userId,
        file_ids: "",
        model: "gpt-4o-2024-11-20"
      };

      this.ajax
        .post("https://gpt4.cocorobo.cn/ai_agent_park_chat", parm)
        .then(res => {
          let _data = res.data.FunctionResponse;
          let _copyData = JSON.parse(JSON.stringify(this.data));
          _copyData.jsonData.content = _data.message;
          // _copyData.jsonData.dataFileList = [];
          // _copyData.jsonData.fileList = [];
          _copyData.json_data = JSON.stringify(_copyData.jsonData);
          if (this.historyResult.length == 0) {
            this.historyResult.push(_copyData.jsonData);
          } else {
            this.historyResult.splice(
              this.showIndex + 1,
              0,
              _copyData.jsonData
            );
          }
          this.changeShowIndex(1);
          this.loading = false;
					this.$nextTick(()=>{

						this.editEcharts(true);
						})
        })
        .catch(err => {
          this.loadNum = 2;
          // this.$message.error("AI无法识别优化");
          this.loading = false;
        });
    },
    delBtn() {
      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          this.$emit("delItem", this.data.id);
        })
        .catch(_ => {
          console.log("取消");
        });
    },
    changeShowIndex(value) {
      if (this.historyResult.length == 0) return;
      if (value == -1) {
        if (this.showIndex > 0) this.showIndex--;
      } else if (value == 1) {
        if (this.showIndex < this.historyResult.length - 1) this.showIndex++;
      }
      let _copyData = JSON.parse(JSON.stringify(this.data));
      let _oldCopyDate = JSON.parse(JSON.stringify(this.data));
      _copyData.jsonData = this.historyResult[this.showIndex];
      _copyData.json_data = JSON.stringify(_copyData.jsonData);
      _oldCopyDate.json_data = JSON.stringify(_oldCopyDate.jsonData);
      // 一样就不用更新了
      if (JSON.stringify(_copyData) == JSON.stringify(_oldCopyDate)) return;
      // this.data = _copyData;
      this.$emit("editItem", this.data.id, _copyData);
      this.$emit("saveItem", this.data.id, _copyData);
    },
    convertToSeconds(time) {
      let parts = time.split(":");
      let seconds = +parts[0] * 3600 + +parts[1] * 60 + +parts[2];
      return seconds;
    },
    changeNameSuccess(newName) {
      let _copyData = JSON.parse(JSON.stringify(this.data));
      _copyData.jsonData.anotherName = newName;
      _copyData.json_data = JSON.stringify(_copyData.jsonData);
      this.$emit("editItem", this.data.id, _copyData);
      this.$emit("saveItem", this.data.id, _copyData);
      // this.$refs.editNameDialogRef.close();
    },
    editTitleFn() {
      if (!this.tid) return this.$message.info("请新建课堂，或选择历史课堂");
      this.form.name = this.data.jsonData.anotherName
        ? this.data.jsonData.anotherName
        : this.data.jsonData.name;
      this.editTitle = true;
      this.$nextTick(() => {
        this.$refs.editNameInputRef.focus();
      });
      // this.$refs.editNameDialogRef.open(this.title)
    },
    editNameCheckFn() {
      if (!this.editTitle) return;
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.editTitle = false;
          this.changeNameSuccess(this.form.name);
        } else {
          this.$nextTick(() => {
            this.$refs.editNameInputRef.focus();
            this.$message.error("该名称不符合规则");
          });
        }
      });
    },
    getSpectrogram(_dataList, type = 1) {
      if (type === 0) {
				try {
					this.loading = true;
				this.openItem = false;
        return this.getContentTable().then(res => {
          if (res.length <= 0) {
            this.loadNum = 2;
            this.loading = false;
            return this.$message.error("在正文中未找到表格数据");
          }

          let _tableData = res;

					let _delIndex = _tableData.findIndex(i=>i.includes(this.converter("时间点")))

					_tableData = _tableData.slice(_delIndex+1)

          let _result = [];
          let identity = "老师"; //0：老师 1：学生
          let startTime = "";
          let endTime = "";
          let sumTime = 0;

          _dataList.forEach((item, index) => {
            if (index == 0) {
              //第一个
              identity = item.role;
              startTime = item.startTime;
              endTime = item.endTime;
              sumTime = this.convertToSeconds(item.time);
              return;
            }
            if (item.role == identity) {
              //没更换角色
              sumTime += this.convertToSeconds(item.time);
              endTime = item.endTime;
            } else {
              //更换角色了
              _result.push({
                startTime: startTime,
                endTime: endTime,
                identity: identity,
                sumTime: sumTime
              });
              identity = item.role;
              startTime = item.startTime;
              endTime = item.endTime;
              sumTime = this.convertToSeconds(item.time);
            }
          });

          let breakpoint = [];

					breakpoint = _tableData.map(i=>this.convertToSeconds(i[0]))

          _result = _result.filter(
            i =>
              i.identity == this.converter("老师") ||
              i.identity == this.converter("学生")
          );
          // let
          let _data = {
            data: [],
            breakpoint: []
          };

          _data.data = _result.map(i => ({role:i.identity,type:i.identity==this.converter("老师")?0:1,value:i.sumTime}));
          _data.breakpoint = breakpoint;
          let _copyData = JSON.parse(JSON.stringify(this.data));
          _copyData.jsonData.spectrogramData = _data;
          _copyData.json_data = JSON.stringify(_copyData.jsonData);
          if (this.historyResult.length == 0) {
            this.historyResult.push(_copyData.jsonData);
          } else {
            this.historyResult.splice(
              this.showIndex + 1,
              0,
              _copyData.jsonData
            );
          }
          this.changeShowIndex(1);
          this.loading = false;

          // console.log(_dataList);
          // console.log(_tableData);
        });
				} catch (e) {
					this.loadNum = 2;
          this.loading = false;
          return this.$message.error("数据格式错误");
				}
      }
      this.$nextTick(() => {
        this.loading = true;
        this.openItem = false;
        this.loadNum = 1;
        let type = 0; //0 用agentId  1:用提示词 3:啥都没有
        let assistant =
          this.dialogTagDataList.find(i => i.id == this.data.jsonData.mId) ||
          this.dialogTagDataList.find(i => i.name == this.data.jsonData.name);

        let _msg = `使用文件检索的方式完整的去分析文件内容，并请完全按照要求输出。`;

        if (!assistant) {
          this.loading = false;
          this.loadNum = 2;
          type = 3;
          return this.$message.error("未找到对应的AI助手");
        }

        if (assistant.tips) {
          type = 1;
        } else if (assistant.agentid) {
          type = 0;
        } else {
          this.loading = false;
          this.loadNum = 2;
          type = 3;
          return this.$message.error("未找到对应的AI助手");
        }

        // console.log('👇')
        // return console.log(_msg)
        let parm = {
          assistant_id:
            type == 0
              ? assistant.agentid
              : "f8e1ebb2-2e0d-11ef-8bf4-12e77c4cb76b",
          message: type == 0 ? _msg : assistant.tips,
          session_name: uuidv4(),
          userId: this.userId,
          file_ids: this.fileId ? [this.fileId] : "",
          model: "gpt-4o-2024-11-20"
					// model: "gpt-4o-mini"
        };

        // 👇
        // const _uid = uuidv4();
        // let parm = {
        // 	assistant_id: assistant ? assistant.value : null,
        // 	userId: this.userId, //602def61-005d-11ee-91d8-005056b86db5
        // 	message:
        // 		"请使用代码解析器获取文件，帮我根据要求完整的分析，输出请按照要求。",
        // 	session_name: new Date().getTime(),
        // 	uid: _uid,
        // 	file_ids: this.fileId ? [this.fileId] : [],
        // };
        if (!parm.assistant_id) {
          this.loading = false;
          this.loadNum = 2;
          return this.$message.error("未找到对应的AI助手");
        }
        // this.ajax
        // 	.post("https://gpt4.cocorobo.cn/ai_agent_park_chat_new", parm)
        // 	.then((res) => {
        // 		if (res.data.FunctionResponse.result == "发送成功") {
        // 		} else {
        // 			this.$message.warning(res.data.FunctionResponse.result);
        // 		}
        // 	})
        // 	.catch((err) => {
        // 		console.log(err);
        // 	});
        // this.getAtAuContent(_uid);
        // 👆

        this.ajax
          .post("https://gpt4.cocorobo.cn/ai_agent_park_chat", parm)
          .then(res => {
            let _data = res.data.FunctionResponse;
            // if (
            // 	!_data.message ||
            // 	_data.message.indexOf("由于我无法直接访问您上传的文件内容") > -1
            // ) {
            // 	this.loading = false;
            // 	this.loadNum = 2;
            // 	// this.$message.error("AI无法识别优化");
            // 	return
            // }
            let _copyData = JSON.parse(JSON.stringify(this.data));
            // _copyData.jsonData.result = "";
            _copyData.jsonData.content = _data.message;
            _copyData.jsonData.dataFileList = [];
            _copyData.jsonData.fileList = [];
            _copyData.json_data = JSON.stringify(_copyData.jsonData);
            if (this.historyResult.length == 0) {
              this.historyResult.push(_copyData.jsonData);
            } else {
              this.historyResult.splice(
                this.showIndex + 1,
                0,
                _copyData.jsonData
              );
            }
            this.changeShowIndex(1);
            this.loading = false;
						this.$nextTick(()=>{
							
							this.editEcharts(true);
						})
          })
          .catch(err => {
            this.loadNum = 2;
            // this.$message.error("AI无法识别优化");
            this.loading = false;
          });
      });
    },
    getContentTable() {
      return new Promise(resolve => {
        let _content = this.data.jsonData.content;
        const md = new markdownIt();
        let _contentHtml = md.render(_content);

        let _contentTableList = [];
        const rowRegex = /<tr[^>]*>([\s\S]*?)<\/tr>/g; // 匹配表格行，[\s\S] 匹配所有字符
        const cellRegex = /<(th|td)[^>]*>([\s\S]*?)<\/\1>/g; // 匹配单元格，[\s\S] 匹配所有字符

        let rowMatch;
        while ((rowMatch = rowRegex.exec(_contentHtml)) !== null) {
          const rowContent = rowMatch[1]; // 每一行的内容
          const rowData = [];
          let cellMatch;

          // 匹配每个单元格 (th 或 td)
          while ((cellMatch = cellRegex.exec(rowContent)) !== null) {
            let _text = cellMatch[2].trim();
            _text = _text.replace(/&[a-zA-Z]+;/g, "");
            _text = _text.replace(/<\/?[^>]+(>|$)/g, "");
            rowData.push(_text); // 将每个单元格的内容添加到当前行的数组中
          }

          // 如果该行有数据，推送到 _contentTableList 中
          if (rowData.length) {
            _contentTableList.push(rowData);
          }
        }

        // 输出提取的表格数据

        resolve(_contentTableList);
      });
    },
		moveDown(e) {
			if(!this.isDrag)return;
      this.isDragging = true;
      this.startY = e.clientY;
      this.$nextTick(() => {
        this.dialogTagList.forEach(i => {
          this.dragBoxList.push(
            ...this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs
              .dragBoxRefTop
          );
					if(this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs.dragBoxRefBottom.length>0){
						this.dragBoxList.push(
            ...this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs
              .dragBoxRefBottom
          );
					}else if(this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs.dragBoxRefBottom){
						this.dragBoxList.push(this.$parent.$parent.$refs[`analysis_${i.value}`][0].$refs.dragBoxRefBottom);
					}
          
        });
        // 禁用页面文本选择
        document.body.style.userSelect = "none";
        document.addEventListener("mousemove", this.onMouseMove);
        document.addEventListener("mouseup", this.stopDragging);
      });
    },
    onMouseMove(e) {
      if (!this.isDragging) return;

      const newTop = e.clientY - this.startY; // 计算鼠标移动的Y轴距离

      // // 更新div的top样式，使其跟随鼠标移动
      this.moveTop = newTop;
      // this.dragBoxList.forEach(i=>{
      // 	let _i = i.getBoundingClientRect();
      // 	if(e.clientX>=_i.left && e.clientX<=_i.right && e.clientY>=_i.top && e.clientY<=_i.bottom){
      // 		this.enterDrag = i;
      // 		console.log("👇")
      // 		console.log(e)
      // 	}else{
      // 		this.enterDrag = null;
      // 	}
      // })
      // for (let i = 0; i <= this.dragBoxList.length; i++) {
      //   let _i = this.dragBoxList[i].getBoundingClientRect();
      //   if (
      //     e.clientX >= _i.left &&
      //     e.clientX <= _i.right &&
      //     e.clientY >= _i.top &&
      //     e.clientY <= _i.bottom
      //   ) {
      //     this.enterDrag = this.dragBoxList[i];
      //     console.log("👇");
      //     console.log(e);
      // 		break;
      //   } else {
      //     this.enterDrag = null;
      //   }
      // }
    },
    stopDragging(e) {
      this.isDragging = false;
      try {
        for (let i = 0; i <= this.dragBoxList.length; i++) {
          let _i = this.dragBoxList[i].getBoundingClientRect();
          if (
            e.clientX >= _i.left &&
            e.clientX <= _i.right &&
            e.clientY >= _i.top &&
            e.clientY <= _i.bottom
          ) {
            this.enterDrag = this.dragBoxList[i];
            break;
          } else {
            this.enterDrag = null;
          }
        }
        // 恢复页面的文本选择
        document.body.style.userSelect = "";
        if (!this.enterDrag) {
          this.moveTop = 0;
        } else {
					this.moveTop = 0;
					let moveData = this.enterDrag.getAttribute('type');
					this.$emit("moveAnalysis",{form:`${this.data.Type}_${this.index}_${this.data.tIndex}`,to:moveData})
        }
        // 移除全局的鼠标移动和释放事件
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.stopDragging);
      } catch (error) {
				this.moveTop = 0;
				document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.stopDragging);
			}
    }
  },
  mounted() {
    if (this.data.jsonData.content) {
      this.historyResult.push(this.data.jsonData);
    }
  }
};
</script>

<style scoped>
.analysisItem {
  width: 100%;
  height: auto;

  /* margin: 11.7px 0px; */

  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  transition: 0.3s;
	position: relative;
}

.analysisItem:hover {
  border: 1px solid #3681fc;
}
.text1 {
  color: rgba(54, 129, 252, 1);
}
.text2 {
  color: rgba(23, 196, 105, 1);
}
.ai-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: white;
  border-radius: 5px;
}
.ai-h-left {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  cursor: pointer;
}

.ai-h-l-icon {
  width: 16px;
  height: 16px;
  background: url("../../../../assets/icon/classroomObservation/right.svg")
    no-repeat;
  background-size: 100% 100%;
  margin-right: 10px;
  transition: 0.3s;
}

.ai-h-l-iconActive {
  transform: rotate(90deg);
}
.ai-h-l-text {
  font-size: 18px;
}

.ai-h-right {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
}

.ai-h-right > span {
  width: 18px;
  height: 18px;
  background-size: 100% 100%;
  margin: 0 10px;
  cursor: pointer;
}

.ai-h-right > span > img {
  width: 18px;
  height: 18px;
}

.ai-h-r-icon1 {
  background: url("../../../../assets/icon/classroomObservation/back.svg");
  /* 镜像 */
  transform: scaleX(-1);
}

.ai-h-r-icon2 {
  background: url("../../../../assets/icon/classroomObservation/back.svg");
}

.ai_h_r_iconOpacity {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.ai-h-r-icon3 {
  background: url("../../../../assets/icon/classroomObservation/edit.svg");
  /* display: none; */
}

.ai-header:hover .ai-h-r-icon4 {
  display: block;
}

.ai-h-r-icon4 {
  background: url("../../../../assets/icon/classroomObservation/del.svg");
  /* position: absolute; */
  /* right: -40px; */
  display: none;
}

.analysisItem:hover .ai-h-r-icon4 {
  display: block;
}

.ai-main {
  width: 100%;
  height: auto;
  background-color: white;
  border-radius: 0 0 5px 5px;
  overflow: auto;
  box-sizing: border-box;
  padding: 10px 20px;
}

.a-m-brief {
  font-size: 16px;
  /* 斜体 */
  font-style: italic;
  margin-bottom: 10px;
  color: #6b798e;
}

td,
th {
  padding: 10px;
}

.generate {
  color: #00000099;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.generate > img {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}

.generateSuccess {
  color: #17c469;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.generateSuccess > img {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}

.generateError {
  color: #e60012;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.rtCh {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.rtCh > img {
  max-height: 250px;
}

.rtCh > div {
  margin-top: 20px;
}

.rtCh > div > span {
  margin: 0 10px;
  font-size: 20px;
  font-weight: bold;
  color: #1a7ad3;
  /* 斜体字 */
  font-style: italic;
}

.a_h_l_edit {
  width: 16px;
  height: 16px;
  margin-left: 10px;
  display: none;
  align-items: center;
  justify-content: center;
}

.a_h_l_edit > img {
  width: 100%;
  height: 100%;
}

.ai-h-left:hover .a_h_l_edit {
  display: flex;
}

.a_h_l_t_input {
  width: 25%;
  min-width: 220px;
  height: 100%;
  display: flex;
  align-items: center;
}

.a_h_l_t_input >>> .el-form {
  width: 100%;
  min-width: 220px;
}

.a_h_l_t_input >>> .el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/analysisSpecialItem.vue